import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowUpSmall = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="chevron-up">
        <path
          id="Vector (Stroke)"
          d="M7.46967 5.46967C7.76256 5.17678 8.23744 5.17678 8.53033 5.46967L12.5303 9.46967C12.8232 9.76256 12.8232 10.2374 12.5303 10.5303C12.2374 10.8232 11.7626 10.8232 11.4697 10.5303L8 7.06066L4.53033 10.5303C4.23744 10.8232 3.76256 10.8232 3.46967 10.5303C3.17678 10.2374 3.17678 9.76256 3.46967 9.46967L7.46967 5.46967Z"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

ArrowUpSmall.displayName = 'ArrowUpSmall';
